import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from '@angular/core';
import * as fromInvoiceSetup from '../../../data-services/invoice/setup';
import * as fromShared from '../../../shared';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-invoice-session',
    templateUrl: './invoice-session.component.html',
    styleUrls: ['./invoice-session.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InvoiceSessionComponent
    extends fromShared.EditGrid<fromInvoiceSetup.Session.InvoiceSessionSetup>
    implements OnInit, OnChanges {
    @Input() addresses: SelectItem[] = [];
    @Input() remitAddresses: SelectItem[] = [];
    @Input() billingAddresses: SelectItem[] = [];
    @Input() contracts: SelectItem[] = [];
    sessionTypes = [];
    numCols = 9;
    constructor(private log: LoggingService) {
        super();
    }

    ngOnInit(): void {}
    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (
            changes.items &&
            changes.items.currentValue &&
            changes.items.currentValue.length > 0
        ) {
            this.log.verbose({
                type: 'InvoiceSessionComponent:ngOnChanges',
                changes
            });
            this.selected = [];
        }
    }
}
